import styles from "../showroomForm.css";
import Tabs, {
  TabContent,
  TabNav,
  TabNavItem,
} from "../../../../design-system/components/Tabs/Tabs.jsx";
import tabStyles from "../../../../design-system/components/Tabs/tabs.css";
import InputText from "../../../../design-system/components/InputText/InputText.jsx";
import { FileUpload } from "./FileUpload/FileUpload.jsx";

/**
 * ProjectUpload component for handling project-related file or link uploads in a form.
 *
 * @param {Object} props - The props for the ProjectUpload component.
 * @param {string} props.fieldKey - A unique key identifying the field in the form data.
 * @param {string} [props.label] - The label for the input field.
 * @param {string} [props.description] - Optional description text displayed above the input field.
 * @param {Object} props.formData - An object containing the form data.
 * @param {Function} props.setFormData - A function to update the form data state.
 * @param {boolean} [props.required=false] - Indicates whether the field is required.
 * @param {Function} [props.validate] - Function to validate input values (e.g., link).
 * @param {Function} [props.validateFile] - Function to validate uploaded file.
 * @param {string} [props.error] - An error message to display for validation errors.
 * @param {Function} [props.onTabChange] - Callback function triggered when the tab layout changes.
 * @returns {JSX.Element} A component that renders a file upload or link input, with validation and error handling.
 */
export const ProjectUpload = ({
  fieldKey,
  label,
  description,
  formData,
  setFormData,
  required,
  validate,
  validateFile,
  error,
  onTabChange,
}) => {
  return (
    <div className={styles.formGroup}>
      {label && (
        <h2>
          {label}
          {required && "*"}
        </h2>
      )}
      {description && <p className={styles.description}>{description}</p>}
      <Tabs
        defaultTabId={formData[fieldKey]?.type === "link" ? "link" : "file"} // tabId can not be assumed from type, as type could be "video"
        onChange={onTabChange}
        w100
        theme={"dark"}
      >
        <TabNav>
          <TabNavItem id="file" title="Datei" />
          <TabNavItem id="link" title="Link" />
        </TabNav>
        <TabContent id="file">
          <div className={tabStyles.tabContainer}>
            <FileUpload
              fieldKey={fieldKey}
              formData={formData}
              setFormData={setFormData}
              accept="image/png,image/jpeg,image/gif,image/webp,audio/mpeg,application/pdf,video/mp4"
              validateFile={validateFile}
              error={error}
            />
          </div>
        </TabContent>
        <TabContent id="link">
          <div className={tabStyles.tabContainer}>
            <InputText
              name={fieldKey}
              label="Link"
              value={
                formData[fieldKey] &&
                formData[fieldKey].type === "link" &&
                formData[fieldKey].data
                  ? formData[fieldKey].data
                  : ""
              }
              onChange={(e) => {
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  [fieldKey]: {
                    data: e.target.value,
                    type: "link",
                  },
                }));

                if (validate) validate(e);
              }}
              width100
              error={error}
              theme={"dark"}
            />
          </div>
        </TabContent>
      </Tabs>
    </div>
  );
};
